import * as React from "react";

import { ViewModelSelect } from "../Helpers/StateAccessors/ViewModelSelect";

import { useRedefinedViewModelIndex } from "./RedefinedViewModelIndexContext";
import { createHocDisplayName } from "./TypingUtils";

export function withViewModelSelect<P extends { viewModelSelect: ViewModelSelect }>(
    WrappedComponent: React.NamedExoticComponent<P> | React.ComponentType<P>,
    forwardRef: boolean = false
): React.ComponentType<Omit<P, "viewModelSelect">> {
    function ViewModelSelectWrapper(props: Omit<P, "viewModelSelect">, ref?: unknown): JSX.Element {
        const redefinedViewModelIndex = useRedefinedViewModelIndex();
        const viewModelSelect = React.useMemo(
            () => new ViewModelSelect(true, redefinedViewModelIndex),
            [redefinedViewModelIndex]
        );
        if (forwardRef) {
            // @ts-ignore Баг с HOC-ами https://github.com/Microsoft/TypeScript/issues/28938
            return <WrappedComponent {...props} viewModelSelect={viewModelSelect} ref={ref} />;
        } else {
            // @ts-ignore Баг с HOC-ами https://github.com/Microsoft/TypeScript/issues/28938
            return <WrappedComponent {...props} viewModelSelect={viewModelSelect} />;
        }
    }
    ViewModelSelectWrapper.displayName = createHocDisplayName(WrappedComponent, "ViewModelSelect");
    if (forwardRef) {
        // @ts-ignore Даже не представляю как такое затипизировать
        return React.forwardRef(ViewModelSelectWrapper);
    } else {
        return ViewModelSelectWrapper;
    }
}
